export default "__VITE_ASSET__b8mli72B__"